import { Row, Col } from 'antd';
import React from 'react';
import { DisclaimerBoxWrapper } from './style';

interface BoxProps {
    bgCol: string | undefined;
    icon: JSX.Element;
    text: string | JSX.Element;
}

const DisclaimerBox: React.FC<BoxProps> = ({ bgCol, icon, text }) => {
    return (<DisclaimerBoxWrapper backgroundColor={bgCol}>
        <Row gutter={8}>
            <Col className='pt4'>{icon}</Col>
            <Col>{text}</Col>
        </Row>
    </DisclaimerBoxWrapper>

    )
}

export default DisclaimerBox;